<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Update Dependent's History"
      text="Update for previous year record if current year record is different from previous year"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localDependent.relation_status_id"
                v-validate="'required'"
                :error-messages="errors.collect('relationStatus')"
                :items="relationStatuses"
                data-vv-name="relationStatus"
                data-vv-as="relation status"
                item-text="name"
                item-value="id"
                label="Relation Status"
                :class="{
                  'required':!localDependent.relation_status_id
                }"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">{{ data.item.name }}</span>
                    <span style="width:100px">{{ data.item.description }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              v-show="localDependent.relation_status_id === 2"
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localDependent.education_level"
                v-validate="localDependent.relation_status_id === 2 ? 'required' : ''"
                :error-messages="errors.collect('education_level')"
                :items="educationLevels"
                data-vv-name="educationLevel"
                data-vv-as="education level"
                item-text="name"
                item-value="key"
                label="Education Level"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <span> Disabled? </span>
              <v-radio-group
                v-model="localDependent.is_disabled"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>

            <v-col
              v-if="dependentHistory.relationship_id === 2"
              :cols="localDependent.is_tax_relief ? 6 : 12"
              class="pb-0"
            >
              <span> Tax Relief? </span>
              <v-radio-group
                v-model="localDependent.is_tax_relief"
                class="mt-0"
                row
                @change="localDependent.is_tax_relief ? localDependent.tax_relief_percentage = 100 : localDependent.tax_relief_percentage = 0"
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col
              v-show="dependentHistory.relationship_id === 2 && localDependent.is_tax_relief"
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localDependent.tax_relief_percentage"
                :error-messages="errors.collect('taxReliefPercentage')"
                :items="percentages"
                data-vv-name="taxReliefPercentage"     
                data-vv-as="tax relief percentage"
                item-text="name"
                item-value="key"
                label="Tax Relief Percentage"
                outlined
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localDependent.start_year"
                v-validate="'required'"
                :items="years"
                :error-messages="errors.collect('startYear')"
                data-vv-name="startYear"     
                data-vv-as="start year"
                label="Payroll Start Year"
                item-text="value"
                item-value="id"
                outlined
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localDependent.end_year"
                :items="years"
                :error-messages="errors.collect('endYear')"
                data-vv-name="endYear"     
                data-vv-as="end year"
                label="Payroll End Year"
                item-text="value"
                item-value="id"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      dependentHistory: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localDependent: null,
        years: [],
        relationships: [],
        relationStatuses: [],
        loading: false,
        percentages: [
          { key: 50, name: '50 %' },
          { key: 100, name: '100 %' },
        ],
        educationLevels: [
          { key: 'PRIMARY', name: 'Primary' },
          { key: 'SECONDARY', name: 'Secondary' },
          { key: 'ALEVEL', name: 'A-Level' },
          { key: 'CERTIFICATE', name: 'Certificate' },
          { key: 'MATRICULATION', name: 'Matriculation' },
          { key: 'PREPARATORY_COURSES', name: 'Preparatory Courses' },
          { key: 'DIPLOMA', name: 'Diploma in Malaysia (excluding matriculation/ preparatory courses)' },
          { key: 'OVERSEAS_DIPLOMA', name: 'Overseas Diploma' },
          { key: 'DEGREE', name: 'Degree in Malaysia' },
          { key: 'OVERSEAS_DEGREE', name: 'Overseas Degree' },
          { key: 'MASTER', name: 'Master in Malaysia' },
          { key: 'OVERSEAS_MASTER', name: 'Overseas Master' },
          { key: 'DOCTORATE', name: 'Doctorate in Malaysia' },
          { key: 'OVERSEAS_DOCTORATE', name: 'Overseas Doctorate' },
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localDependent = { ...this.dependentHistory }
        
        this.localDependent.is_tax_relief = this.localDependent.tax_relief_percentage > 0 ? 1 : 0

        Promise.all([
          this.$api.hrisRelationships().list(),
          this.$api.hrisRelationStatuses().list(),
          this.$api.taxReliefs().listYears(),
        ])
          .then(([employee, relationStatus, years]) => {
            this.relationships = employee.data
            this.relationStatuses = relationStatus.data
            this.years = years.data.filter(year => {
              return year < this.$moment().format('YYYY')
            })

            this.loading = false
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisDependentHistories().update(this.dependentHistory.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        if (this.localDependent.relation_status_id !== 2) {
          this.localDependent.education_level = null
        }
        
        return {
          relationship_id: this.localDependent.relationship_id,
          relation_status_id: this.localDependent.relation_status_id,
          is_disabled: this.localDependent.is_disabled,
          is_tax_relief: this.localDependent.relationship_id === 2 ? this.localDependent.is_tax_relief : 1,
          tax_relief_percentage: this.localDependent.is_tax_relief ? this.localDependent.tax_relief_percentage : (this.localDependent.relationship_id === 1 ? 100 : 0),
          education_level: this.localDependent.education_level,
          start_year: this.localDependent.start_year,
          end_year: this.localDependent.end_year,
        }
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:1px
}
</style>
